import {
  ADD_USER_ROLE,
  ADD_USER_ROLE_ERROR,
  ADD_USER_ROLE_START,
  UPDATE_USER_ROLE,
  UPDATE_USER_ROLE_ERROR,
  UPDATE_USER_ROLE_START,
  GET_USER_ROLE,
  GET_USER_ROLE_ERROR,
  GET_USER_ROLE_LIST_PAGEABLE,
  GET_USER_ROLE_LIST_PAGEABLE_START,
  GET_USER_ROLE_LIST_PAGEABLE_ERROR,
  DELETE_USER_ROLE,
  DELETE_USER_ROLE_ERROR,
  DELETE_USER_ROLE_START,
  CLEAR_ERROR_USER_ROLE,
  GET_USER_ROLE_LIST,
  GET_USER_ROLE_LIST_ERROR,
  GET_USER_ROLE_LIST_START,
} from '../actions/types';

const initialState = {
  emptyList: false,
  userRoleList: [],
  userRole: {},
  loading: false,
  error: undefined,
  totalElements: '',
  pageNumber: -1,
  pageSize: 8,
  isLastPage: false,
};

const clearError = (state) => {
  return {
    ...state,
    error: undefined,
  };
};

const addUserRoleStart = (state) => {
  return {
    ...state,
    loading: false,
  };
};

const addUserRoleError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const addUserRole = (state, action) => {
  return {
    ...state,
    loading: false,
    userRoleList: state.userRoleList.concat(action.payload),
  };
};

const updateUserRoleStart = (state) => {
  return {
    ...state,
  };
};

const updateUserRoleError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const updateUserRole = (state, action) => {
  return {
    ...state,

    userRoleList: state.userRoleList.map((userRole) =>
      userRole.id === action.payload.id ? action.payload : userRole
    ),
    loading: false,
  };
};

const findAllUserRolesPageableStart = (state) => {
  return {
    ...state,
    loading: true,
  };
};

const findAllUserRolesPageableError = (state, action) => {
  return {
    ...state,
    error: action.payload,
  };
};

const findAllUserRolesPageable = (state, action) => {
  return {
    ...state,
    userRoleList: [...action.payload.list],
    totalElements: action.payload.totalElements,
  };
};

const deleteUserRoleStart = (state) => {
  return {
    ...state,
    loading: true,
  };
};

const deleteUserRoleError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const deleteUserRole = (state, action) => {
  return {
    ...state,
    loading: false,
    userRoleList: state.userRoleList.filter(
      (userRole) => userRole.id !== action.payload
    ),
  };
};

const findUserRoleByIdStart = (state) => {
  return {
    ...state,
    loading: true,
  };
};

const findUserRoleByIdError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const findUserRoleById = (state, action) => {
  return {
    ...state,
    loading: false,
    userRole: action.payload,
  };
};

const findAllUserRolesStart = (state) => {
  return {
    ...state,
    loading: true,
  };
};

const findAllUserRolesError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const findAllUserRoles = (state, action) => {
  return {
    ...state,
    loading: false,
    userRoleList: action.payload,
  };
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ADD_USER_ROLE:
      return addUserRole(state, action);
    case ADD_USER_ROLE_START:
      return addUserRoleStart(state);
    case ADD_USER_ROLE_ERROR:
      return addUserRoleError(state, action);

    case UPDATE_USER_ROLE:
      return updateUserRole(state, action);
    case UPDATE_USER_ROLE_START:
      return updateUserRoleStart(state);
    case UPDATE_USER_ROLE_ERROR:
      return updateUserRoleError(state, action);

    case GET_USER_ROLE:
      return findUserRoleById(state, action);
    case GET_USER_ROLE_LIST_START:
      return findUserRoleByIdStart(state);
    case GET_USER_ROLE_ERROR:
      return findUserRoleByIdError(state, action);

    case GET_USER_ROLE_LIST_PAGEABLE_START:
      return findAllUserRolesPageableStart(state, action);
    case GET_USER_ROLE_LIST_PAGEABLE:
      return findAllUserRolesPageable(state, action);
    case GET_USER_ROLE_LIST_PAGEABLE_ERROR:
      return findAllUserRolesPageableError(state, action);

    case DELETE_USER_ROLE:
      return deleteUserRole(state, action);
    case DELETE_USER_ROLE_START:
      return deleteUserRoleStart(state);
    case DELETE_USER_ROLE_ERROR:
      return deleteUserRoleError(state, action);
    case CLEAR_ERROR_USER_ROLE:
      return clearError(state);

    case GET_USER_ROLE_LIST:
      return findAllUserRoles(state, action);
    case GET_USER_ROLE_LIST_START:
      return findAllUserRolesStart(state);
    case GET_USER_ROLE_LIST_ERROR:
      return findAllUserRolesError(state, action);

    default:
      return state;
  }
}
